import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"d-flex align-row linkButton"},'div',_vm.$attrs,false),{ ..._vm.$listeners, click: () => {} }),[_c(VBtn,{staticClass:"mr-1 elevation-3",attrs:{"fab":"","x-small":"","depressed":"","color":"primary"},on:{"click":_vm.$listeners.click}},[_c(VIcon,[_vm._v("mdi-plus")])],1),_c('div',{staticClass:"my-auto"},[_c('a',{on:{"click":_vm.$listeners.click}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }